import React from 'react';
import { useSectionItems } from '../../../queries/ats/layout/queries';
import { Layout } from '../../../queries/ats/layout/types';
import { SectionType } from '../section-type/section-type';

interface SectionProps {
  page: Layout.PageView;
  section: Layout.SectionView;
}

export function Section({ page, section }: SectionProps) {
  const { data: items, isLoading } = useSectionItems({ link: section.link });

  if (isLoading) {
    return <SectionType.Skeleton view={section} pageStyle={page.style} />;
  }

  if (items === undefined) {
    return null;
  }

  return <SectionType key={section.link} view={section} data={items} pageStyle={page.style} />;
}
